export function storageFactory(getStorage: () => Storage): Storage {
  let memory: {[key: string]: string} = {}

  function supported() {
    return storageAvailable(getStorage)
  }

  function clear(): void {
    supported() ? getStorage().clear() : (memory = {})
  }

  function getItem(name: string): string | null {
    return supported()
      ? getStorage().getItem(name)
      : Object.prototype.hasOwnProperty.call(memory, 'name')
      ? memory[name] ?? null
      : null
  }

  function key(index: number): string | null {
    return supported() ? getStorage().key(index) : Object.keys(memory)[index] ?? null
  }

  function removeItem(name: string): void {
    supported() ? getStorage().removeItem(name) : delete memory[name]
  }

  function setItem(name: string, value: string): void {
    supported() ? getStorage().setItem(name, value) : (memory[name] = String(value))
  }

  function length(): number {
    return supported() ? getStorage().length : Object.keys(memory).length
  }

  return {
    clear,
    getItem,
    key,
    get length() {
      return length()
    },
    removeItem,
    setItem
  }
}

export const storageAvailable = (getStorage: () => Storage = () => localStorage): boolean => {
  try {
    getStorage().getItem('')
  } catch (error) {
    return false
  }
  return true
}
